import React, { useState } from "react";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ArrowIcon from "../../assets/icons/arrowIcon.svg";
import { StyledAccordion } from "./FormAccordion.styled";

// eslint-disable-next-line react/prop-types
const FormAccordion = ({ title, open, children }) => {
	const [expanded, setExpanded] = useState(open ? true : false);

	return (
		<StyledAccordion
			disableGutters
			className='formAccordion'
			elevation={0}
			expanded={expanded}
			onChange={() => setExpanded(!expanded)}>
			<AccordionSummary
				expandIcon={
					<img
						src={ArrowIcon}
						alt='expand icon'
						className='expandIcon'
						style={{
							transform: expanded ? "rotate(-90deg)" : "rotate(0deg)",
						}}
					/>
				}
				aria-controls='accordion-content'>
				<Typography variant='h6' className='accordionHeader'>
					<span>{title}</span>
					<i className='accordionLine'></i>
				</Typography>
			</AccordionSummary>

			<AccordionDetails>{children}</AccordionDetails>
		</StyledAccordion>
	);
};

export default FormAccordion;
